import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  OnDestroy,
  computed,
  inject,
  input,
} from '@angular/core';
import { SiaI18nService, SiaTranslatePipe } from '@sia/shared';

@Component({
  selector: '[sia-error-hint]',
  templateUrl: './sia-error-hint.component.html',
  styleUrls: ['./sia-error-hint.component.scss'],
  standalone: true,
  imports: [SiaTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaErrorHintComponent implements OnDestroy {
  private siaI18nService = inject(SiaI18nService);

  private _url: string = '';

  statusMessage = input<string | undefined>();
  statusMessages = input<Map<string, string> | undefined>();
  fieldValue = input<any>();
  @HostBinding('class.mat-mdc-form-field-error') statusClass: boolean = true;

  firstStatusMessage = computed(() => {
    const message = this.statusMessage();
    if (message && message.trim()) {
      return message;
    }

    const messages = this.statusMessages();
    if (messages && messages.size) {
      const [firstValue] = messages.values();
      return firstValue ?? null;
    }

    return null;
  });

  @HostListener('window:unload')
  ngOnDestroy() {
    this._url = '';
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}
}
